import { Pipe, PipeTransform } from '@angular/core';
import { NumberWithCommasPipe } from './number-with-commas.pipe';

@Pipe({ name: 'pageInfo' })
export class PageInfoPipe implements PipeTransform {
  transform(page: any): any {

    if (!page) {
      return `0 개중 0 - 0`;
    }

    const numberPipe: NumberWithCommasPipe = new NumberWithCommasPipe();

    let pageInfo: string = `${page?.totalElements || 0} 개중 `;

    pageInfo += page.totalElements > 0 ? numberPipe.transform(page.number * page.size + 1) : '0';
    pageInfo += ' - ';
    pageInfo += (page.number * page.size + page.size > page?.totalElements) ? numberPipe.transform(page.totalElements) : numberPipe.transform(page.number * page.size + page.size);

    return pageInfo;
  }
}
